import React, { useState, useEffect } from "react";
import { createStockage } from "src/service/stockageApi";

export const AddBoxDialog = ({ addBox, setAddBox, stockagePoints = [], getStockageColor }) => {
  const [open, setOpen] = useState(false);
  const [boxName, setBoxName] = useState("");
  const [selectedStockagePoint, setSelectedStockagePoint] = useState("");
  const [boxPostData, setBoxPostData] = useState([]);
  const [cat, setCat] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCreateCategories = (e) => {
    setCat(e.target.checked);
  };

  useEffect(() => {
    // Créer le nom de la boîte avec le suffixe du point de stockage
    const fullBoxName = selectedStockagePoint 
      ? `${boxName} - ${selectedStockagePoint}`
      : boxName;
      
    const data = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      boxName: fullBoxName,
      motherBox: true,
    };
    console.log('Données préparées:', data);
    setBoxPostData(data);
  }, [boxName, selectedStockagePoint]);

  const handleAddBox = async () => {
    if (!boxName.trim()) {
      alert('Veuillez entrer un nom de boîte');
      return;
    }
    
    if (stockagePoints.length > 0 && !selectedStockagePoint) {
      alert('Veuillez sélectionner un point de stockage');
      return;
    }
    
    handleClose();
    try {
      console.log('Données envoyées à l\'API:', boxPostData);
      const response = await createStockage(boxPostData);
      console.log('Réponse de l\'API:', response);
      setAddBox(response.id);
      setBoxName("");
      setSelectedStockagePoint("");
    } catch (error) {
      console.error('Erreur lors de la création:', error);
      alert('Erreur lors de la création de la boîte');
    }
  };

  return (
    <div>
      <button
        onClick={handleClickOpen}
        className="px-4 py-2 border border-[#1b9faa] text-[#1b9faa] rounded-md hover:bg-[#1b9faa] hover:text-white transition-colors"
      >
        Nouvelle Boite
      </button>

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[400px] p-6">
            <h2 className="text-xl font-semibold mb-4">Ajouter une Boite</h2>
            
            <div className="mb-4">
              <p className="text-gray-600 mb-4">
                Pour ajouter une boite, veuillez entrer le nom de la boite et sélectionner un point de stockage.
              </p>
              
              <input
                type="text"
                placeholder="Nom de la boite"
                value={boxName}
                onChange={(e) => setBoxName(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
                autoFocus
              />
              
              {stockagePoints.length > 0 && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Point de stockage *
                  </label>
                  <div className="grid grid-cols-2 gap-2">
                    {stockagePoints.map((point, index) => (
                      <button
                        key={point}
                        type="button"
                        onClick={() => setSelectedStockagePoint(point)}
                        className={`p-3 rounded-md border-2 transition-colors ${
                          selectedStockagePoint === point
                            ? 'border-gray-800 shadow-md'
                            : 'border-gray-300 hover:border-gray-400'
                        }`}
                        style={{
                          backgroundColor: selectedStockagePoint === point 
                            ? getStockageColor(index) + '20' 
                            : 'white'
                        }}
                      >
                        <div className="flex items-center space-x-2">
                          <div 
                            className="w-4 h-4 rounded-full"
                            style={{ backgroundColor: getStockageColor(index) }}
                          />
                          <span className="font-medium">{point}</span>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-end space-x-2">
              <button
                onClick={handleClose}
                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                Annuler
              </button>
              <button
                onClick={handleAddBox}
                className="px-4 py-2 bg-[#1b9faa] text-white rounded-md hover:bg-[#15808a]"
              >
                Créer la boite
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
